// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBsdQgJw7lud0pt7zqhYFL3Q9TeEP4iJyg",
  authDomain: "ceylon-authentic-travels-173b3.firebaseapp.com",
  projectId: "ceylon-authentic-travels-173b3",
  storageBucket: "ceylon-authentic-travels-173b3.firebasestorage.app",
  messagingSenderId: "547893626351",
  appId: "1:547893626351:web:092799c62b3a375e48a21a",
  measurementId: "G-S3FDYN8SWM"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
